import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnowledgeBaseService, KBRevision } from '../../services/knowledge-base.service';

@Component({
  selector: 'app-kb-revision-history',
  templateUrl: './kb-revision-history.component.html',
  styleUrls: ['./kb-revision-history.component.css']
})
export class KbRevisionHistoryComponent implements OnInit {
  revisions: KBRevision[] = [];
  selectedRevision: KBRevision = null;
  articleSlug = '';
  categorySlug = '';
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private kb: KnowledgeBaseService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.articleSlug = params['articleSlug'];
      this.categorySlug = params['categorySlug'];
      this.loading = true;

      this.kb.getArticleBySlug(this.articleSlug).subscribe(article => {
        if (article) {
          this.kb.getRevisions(article.id).subscribe(revs => {
            this.revisions = revs;
            this.loading = false;
          });
        }
      });
    });
  }

  viewRevision(rev: KBRevision) {
    if (rev.content) {
      this.selectedRevision = rev;
      return;
    }
    this.kb.getRevision(rev.id).subscribe(full => {
      this.selectedRevision = full;
    });
  }

  closeRevision() {
    this.selectedRevision = null;
  }
}
